/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type MutationResult = "failure" | "skipped" | "success" | "%future added value";
export type obligationsDeleteObligationMutationVariables = {
    readonly obligation_id: string;
};
export type obligationsDeleteObligationMutationResponse = {
    readonly deleteObligation: ({
        readonly obligation_id: string | null;
        readonly result: MutationResult;
        readonly description: string | null;
        readonly errors: ReadonlyArray<string | null> | null;
    }) | null;
};
export type obligationsDeleteObligationMutation = {
    readonly response: obligationsDeleteObligationMutationResponse;
    readonly variables: obligationsDeleteObligationMutationVariables;
};



/*
mutation obligationsDeleteObligationMutation(
  $obligation_id: String!
) {
  deleteObligation(obligation_id: $obligation_id) {
    obligation_id
    result
    description
    errors
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "obligation_id",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "deleteObligation",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "obligation_id",
                    "variableName": "obligation_id"
                }
            ],
            "concreteType": "DeleteObligation",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "obligation_id",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "result",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "errors",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "obligationsDeleteObligationMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "obligationsDeleteObligationMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "obligationsDeleteObligationMutation",
            "id": null,
            "text": "mutation obligationsDeleteObligationMutation(\n  $obligation_id: String!\n) {\n  deleteObligation(obligation_id: $obligation_id) {\n    obligation_id\n    result\n    description\n    errors\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '77cc7c7ab8921f9aa2cd550907c3254e';
export default node;
